angular
	.module 'App.Module.ReturnReasonCode', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'return_reason_codes',
				url: '/return_reason_codes',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@return_reason_codes":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Stock.Stock'
					searchParams:
						repositoryName: 'ReturnReasonCodeRepository'
						title: 'return.reason.codes'
						attribute: 'code'
						itemTemplate: '@app/return-reason-code/return-reason-code.search-result.view.html'

			.state 'return_reason_codes.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					returnReasonCode: (ReturnReasonCodeRepository, $stateParams) ->
						return ReturnReasonCodeRepository.getEntity($stateParams.id)

			.state 'return_reason_codes.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'ReturnReasonCodeController'
						controllerAs: 'vm'
						templateUrl: '@app/return-reason-code/return-reason-code.view.html'
